import { DateCellComponent } from '@alfresco/adf-core';
import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'wk-datatable-cell',
  template: `
    <span
      class="adf-datatable-cell-value"
      title="{{ tooltip | date : 'short' }}"
      class="adf-datatable-cell-value"
      [attr.aria-label]="value$ | async | date : 'short'"
    >
      {{ value$ | async | date : 'short' }}
    </span>
  `,
  encapsulation: ViewEncapsulation.None,
  host: { class: 'adf-date-cell adf-datatable-content-cell' },
  standalone: false,
})
export class WkDateCellComponent extends DateCellComponent {
  context: any;

  protected updateValue(): void {
    if (this.context?.data && this.context.row && this.context.col) {
      this.row = this.context.row;
      const value = this.context.data.getValue(
        this.context.row,
        this.context.col,
        this.resolverFn
      );

      this.value$.next(value);

      if (!this.tooltip) {
        this.tooltip = value;
      }
    }
  }
}
